import { createHookContext } from '@clover-util/react-context';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IntercomWrapper } from 'services/intercom';

export const INTERCOM_DISABLED_ROUTES = ['/build-your-own', '/welcome'];

export const { IntercomProvider, useIntercom } = createHookContext('Intercom', () => {
  const location = useLocation();

  useEffect(() => {
    const shouldDisableIntercom = INTERCOM_DISABLED_ROUTES.some(route => location.pathname.includes(route));

    shouldDisableIntercom ? IntercomWrapper.shutdown() : IntercomWrapper.boot();
  }, [location.pathname]);
});
